"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Handle navigation (mainly in handheld view)
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
const _main_1 = require("../_main");
_main_1.txGs1Base.panels = {};
_main_1.txGs1Base.panels.filter = {
    scrollPosition: 0,
    open: function () {
        var currentScrollPos, $panel;
        _main_1.txGs1Base.panels.filter.scrollPosition = $(document).scrollTop();
        $panel = $('#handheld_panel');
        $panel.css({
            'height': $(window).height() - 45
        });
        $('body').addClass('filter-panel-visible');
        $('#wrapper').css({
            'top': -(_main_1.txGs1Base.panels.filter.scrollPosition)
        });
    },
    close: function () {
        $('body').removeClass('filter-panel-visible');
        $(document).scrollTop(_main_1.txGs1Base.panels.filter.scrollPosition);
        $('#wrapper').removeAttr('style');
    },
    attach: function () {
        var $body, $filterCaller, $targetElements, $panel, $overlay, $filterOptions;
        $body = $('body');
        $targetElements = $('[data-filter-panel]');
        $filterOptions = $targetElements.find('a, :input, select');
        if ($filterOptions.length > 0) {
            $panel = $('<div id="handheld_filter_panel_wrapper"><div id="handheld_filter_panel"><div class="inner"></div></div></div>');
            $overlay = $('#handheld_panel_overlay');
            $body.append($panel);
            $panelInner = $panel.find('#handheld_filter_panel > .inner');
            $panel.prepend('<a href="#" class="btn-primary no-txt close-btn" data-close-filter-panel="1" id="handheld_filter_panel_close">' +
                '	<span class="icon" aria-hidden="true"></span>' +
                '	<span class="btntxt">Close</span>' +
                '</a>');
            $targetElements.each(function (index, targetElement) {
                var $targetElement = $(targetElement);
                $filterCaller = $('<a href="#" class="btn-secondary btn-margin filter" ' +
                    '		data-filter-panel-target="' + $targetElement.data('filterPanel') + '" id="filter_caller">' +
                    '	<span class="icon" aria-hidden="true"></span>' +
                    '	<span class="btntxt">' + $targetElement.find('[data-is-filter-caller-title]').text() + '</span>' +
                    '</a>');
                $filterCaller.insertBefore($targetElement);
                $filterCaller.on('click', function (event) {
                    event.preventDefault();
                    $filterCaller.addClass('active');
                    $panelInner.empty();
                    $('#handheld_filter_panel').removeAttr('style');
                    _main_1.txGs1Base.panels.filter.populate($filterCaller.data('filterPanelTarget'));
                    _main_1.txGs1Base.panels.filter.open();
                });
                if ($targetElement.data('filterPanel') === 'newsArchive') {
                    $filterCaller.insertBefore('.news-list-container');
                }
            });
            $('#handheld_filter_panel_close').on('click', function (event) {
                event.preventDefault();
                _main_1.txGs1Base.panels.filter.close();
            });
        }
    },
    detach: function () {
        $('#handheld_filter_panel_wrapper').remove();
        $('[data-filter-panel-target]').remove();
    },
    populate: function (target) {
        var $targetElement = $('[data-filter-panel="' + target + '"]'), $populateData = {}, $panelInner;
        $panelInner = $('#handheld_filter_panel > .inner');
        $populateData = $targetElement.clone(true, true);
        $panelInner.html($populateData);
        $panelInner.find('label, input, select, textarea').each(function (intex, item) {
            var $item = $(item);
            $item.attr('id', $item.attr('id') + '_js_cloned');
            $item.attr('for', $item.attr('for') + '_js_cloned');
        });
    },
    initialize: function () {
        /**
         * Register enter and exit functions for handheld breakpoint
         *
         * @memberOf txGs1Base.respond
         * @type {*}
         */
        _main_1.txGs1Base.respond.addFunc({
            breakpoint: ['handheld', 'tablet_portrait'],
            enter: function () {
                'use strict';
                _main_1.txGs1Base.panels.filter.attach();
            },
            exit: function () {
                'use strict';
                _main_1.txGs1Base.panels.filter.detach();
            }
        });
    }
};
exports.default = {};
